import { Link } from "react-router-dom";
import { ShieldOff } from "Components/ui/icons";

import { Button, EmptyState } from "Components/ui";

/** Shown in place of a page the signed-in user has no permission for. */
const Forbidden = () => (
  <div className="flex min-h-[70vh] w-full items-center justify-center px-6">
    <EmptyState
      icon={<ShieldOff />}
      title="You don't have access to this page"
      description="Your role doesn't include this permission. Ask a super admin to update your role if you need it."
      action={
        <Button asChild variant="secondary">
          <Link to="/dashboard">Go to dashboard</Link>
        </Button>
      }
    />
  </div>
);

export default Forbidden;
